import { MiniGridDashboardCacheDataService } from '@/services/MiniGridDashboardCacheDataService'

export const namespaced = true

export const state = {
    miniGridDashboardCacheDataService: new MiniGridDashboardCacheDataService(),
    /** Lightweight list for dropdown: { id, name, data_stream }[] */
    miniGridsCacheData: [],
    /** Full dashboard data for the currently selected mini-grid */
    miniGridCacheData: {
        id: null,
        period: {},
        targets: {},
        tickets: [],
        miniGridData: {},
        totalConnections: 0,
        newConnections: 0,
        revenue: 0,
    }
}

export const mutations = {
    SET_MINI_GRIDS_DATA (state, miniGridsCacheData) {
        state.miniGridsCacheData = miniGridsCacheData || []
    },
    /** Set current mini-grid dashboard from API (single object) */
    SET_MINI_GRID_DATA_DIRECT (state, data) {
        state.miniGridCacheData = data && (typeof data === 'object' && !Array.isArray(data))
            ? { ...data }
            : { id: null, period: {}, targets: {}, tickets: [], miniGridData: {}, totalConnections: 0, newConnections: 0, revenue: 0 }
    },
    /** Legacy: pick one from list by id (used when list contained full data) */
    SET_MINI_GRID_DATA (state, id) {
        const found = (state.miniGridsCacheData || []).find(c => c.id === parseInt(id))
        state.miniGridCacheData = found ? { ...found } : state.miniGridCacheData
    },
}

export const actions = {
    /** Fetch lightweight list for dropdown (GET index). Does not build dashboard. */
    list ({ commit, state }) {
        return state.miniGridDashboardCacheDataService.list()
            .then(response => {
                commit('SET_MINI_GRIDS_DATA', response)
            })
            .catch(error => {
                throw error
            })
    },
    /** Build cache for one mini-grid and set as current (PUT with miniGridId). Returns single mini-grid data. */
    update ({ commit, state }, { miniGridId, from = null, to = null } = {}) {
        return state.miniGridDashboardCacheDataService.update(from, to, miniGridId)
            .then((response) => {
                const data = response && (Array.isArray(response) ? response[0] : response)
                if (data && typeof data === 'object' && data.id != null) {
                    commit('SET_MINI_GRID_DATA_DIRECT', data)
                }
                return response
            })
            .catch(error => {
                throw error
            })
    },
    /** GET one mini-grid dashboard from cache. If empty, build it (PUT) then set. */
    fetchDashboard ({ commit, state }, miniGridId) {
        return state.miniGridDashboardCacheDataService.detail(miniGridId)
            .then((response) => {
                const data = response && (Array.isArray(response) ? response[0] : response)
                const hasData = data && typeof data === 'object' && (data.id != null || (data.period != null && Object.keys(data.period).length > 0))
                if (hasData) {
                    commit('SET_MINI_GRID_DATA_DIRECT', data)
                    return data
                }
                return state.miniGridDashboardCacheDataService.update(null, null, miniGridId)
                    .then((updateResponse) => {
                        const single = updateResponse && (Array.isArray(updateResponse) ? updateResponse[0] : updateResponse)
                        if (single && single.id != null) {
                            commit('SET_MINI_GRID_DATA_DIRECT', single)
                        }
                        return single
                    })
            })
            .catch(error => {
                throw error
            })
    },
    get ({ commit }, id) {
        commit('SET_MINI_GRID_DATA', id)
    },
    updateByPeriod ({ commit, state }, { from, to, miniGridId }) {
        return state.miniGridDashboardCacheDataService.update(from, to, miniGridId)
            .then(response => {
                const single = response && (Array.isArray(response) ? response[0] : response)
                if (single && single.id != null) {
                    commit('SET_MINI_GRID_DATA_DIRECT', single)
                }
                return response
            })
            .catch(error => {
                throw error
            })
    },
}

export const getters = {
    getMiniGridsData: state => state.miniGridsCacheData,
    getMiniGridData: state => state.miniGridCacheData,
}
